import { connect } from 'react-redux'
import { googleAnalyticsEvent } from 'Modules/googleAnalytics/actions'
import { contactMortgageBroker } from 'Modules/mortgageBroker/actions'
import { openModal } from 'Modules/modals/actions'
import PreApproved from './PreApproved'

const actions = {
  openModal,
  googleAnalyticsEvent,
  contactMortgageBroker,
}

export default connect(state => ({
  disableNewTab: state.app.disableNewTab || state.app.mobileBrowser,
  userIsAuthentificated: state.userData.userIsAuthentificated,
  contactBrokerSuccess: state.mortgageBroker.contactBrokerSuccess,
  isFetching: state.mortgageBroker.isFetching,
  user: state.userData.user,
  contactBrokerFailure: state.mortgageBroker.contactBrokerFailure,
  contactBrokerMsg: state.mortgageBroker.contactBrokerMsg,

}), actions)(PreApproved)
